import styled from "styled-components";

const ActionContainer = styled.div`
  .ant-list-item-meta {
    padding: 20px;
    text-align: center;

    a {
      color: #1890ff;
    }
  }
`;

export { ActionContainer };
